(()=>{
 const track=document.getElementById('productGalleryTrack');
 const nav=document.querySelector('.product-gallery-dots');
 if(!track||!nav)return;
 const slides=[...track.children],mobile=matchMedia('(max-width:700px)');
 const titles=['Sampler product image','Flavor and calm customer review','Blue Raspberry customer review','Best-selling flavors sampler','Customer proof and guarantee'];
 slides.forEach((slide,index)=>{
  const button=document.createElement('button');button.type='button';
  button.setAttribute('aria-label',titles[index]||`Image ${index+1}`);
  button.setAttribute('aria-controls','productGalleryTrack');
  button.onclick=()=>track.scrollTo({left:slide.offsetLeft-track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  nav.append(button);
 });
 const buttons=[...nav.children];
 const update=()=>{
  const start=track.getBoundingClientRect().left;
  let closest=0,distance=Infinity;
  slides.forEach((slide,index)=>{const delta=Math.abs(slide.getBoundingClientRect().left-start);if(delta<distance){distance=delta;closest=index;}});
  buttons.forEach((button,index)=>button.setAttribute('aria-current',String(index===closest)));
 };
 track.addEventListener('scroll',update,{passive:true});
 track.addEventListener('keydown',event=>{
  if(!mobile.matches||event.target!==track||!['ArrowLeft','ArrowRight'].includes(event.key))return;
  event.preventDefault();const active=buttons.findIndex(button=>button.getAttribute('aria-current')==='true');
  buttons[Math.max(0,Math.min(buttons.length-1,active+(event.key==='ArrowRight'?1:-1)))].click();
 });
 mobile.addEventListener('change',()=>{track.scrollLeft=0;update();});
 window.addEventListener('resize',update);update();
})();
